module.exports = __webpack_public_path__ + "e96e8b847c9747d41381d0442e780158.svg";